<template>
  <div @click="toMore" class="box">
    <div :maxFontZoomScale="1.0" class="left">相关协议和公告</div>
    <div class="right">
      <div :maxFontZoomScale="1.0" class="content">产品合同等</div>
      <img class="right-arrow" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png"/>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 数据
  },

  computed: {
    // 基金名
    fundName() {
      return this.elementData.fundName;
    },
  },

  methods: {
    // 跳转到相关协议和公告
    toMore() {
      this.$wxSendTrack('wxgdpzy.jcxx.gdcpht.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      tool.goDetail(`fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcIndex/index?fundCode=${this.fundCode}&fundName=${this.fundName}&index=3`, this.$goFundApp);
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  background-color: #ffffff;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  border-radius: 12px;
  padding-top: 24px;
  padding-bottom: 24px;
}

.left {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
  font-weight: bold;
  margin-left: 24px;
}

.right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #666666;
  text-align: right;
}

.right-arrow {
  /* px2wx:change next */
  width: 32px;
  height: 32px;
  margin-left: 8px;
}

</style>
